import { DataGrid, IColDefPlus, NumberFormat } from '@m27/common';

export class DataGridColumns {

    static PermitSearchResults(): IColDefPlus[] {
        return [
            DataGrid.ColumnBuilder()
                .ForNumber('PermitId', 'Permit Id', 80)
                .Hidden()
                .Build(),

            DataGrid.ColumnBuilder()
                .ForNumber('Year', 'Year', 60)
                .NumberFormat(NumberFormat.None)
                .Build(),

            DataGrid.ColumnBuilder()
                .ForString('Crop', 'Crop', 85)
                .Build(),

            DataGrid.ColumnBuilder()
                .ForString('PioneerName', 'Pioneer Name', 130)
                .Build(),

            DataGrid.ColumnBuilder()
                .ForString('AgencyName', 'Agency Name', 150)
                .Build(),

            DataGrid.ColumnBuilder()
                .ForString('AuthorizationId', 'Authorization Id', 150)
                .Build(),

            DataGrid.ColumnBuilder()
                .ForString('Type', 'Type', 200)
                .Build(),

            DataGrid.ColumnBuilder()
                .ForString('Status', 'Status', 100)
                .Build(),

            DataGrid.ColumnBuilder()
                .ForDate('ValidDate', 'Valid Date', 100)
                .Build(),

            DataGrid.ColumnBuilder()
                .ForDate('ExpiresDate', 'Expiration Date', 110)
                .Build(),

            DataGrid.ColumnBuilder()
                .ForDate('LastPlantDate', 'Last Plant Date', 110)
                .Build()
        ];
    }
}
